import { deviceNames } from '@ubnt/link-core/modules/devices';

export const AP_ID = 'ap0';
export const MESH_AP_ID = 'ap1';
export const CLIENT_ID = 'client0';
export const DEFAULT_CLIENT = deviceNames.Wifi7_Device;
export const DEFAULT_CUSTOM_CLIENT_NAME = 'Custom Client';
